<template>
  <div class="course-create-wrap">
    <a-form :form="form">
      <a-card
        :bordered="false"
        style="box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.06)"
      >
        <div class="info-title">教师信息</div>
        <div
          class="info-content"
          style="padding-top: 25px; padding-bottom: 30px"
        >
          <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom: 12px"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 14 }"
                label="头像"
              >
                <a-upload
                  v-decorator="[
                    'avatar',
                    {
                      valuePropName: 'file',
                      getValueFromEvent: normFile,
                      rules: [{ required: true, message: '请上传头像' }],
                    },
                  ]"
                  listType="picture-card"
                  :showUploadList="false"
                  :action="uploadAction"
                  :headers="headers"
                  :beforeUpload="imgBeforeUpload"
                  @change="courseCoverChange"
                >
                  <img v-if="avatar" :src="avatar" style="width: 100%" />
                  <div v-else>
                    <a-icon :type="faceloading ? 'loading' : 'plus'" />
                    <div class="ant-upload-text"></div>
                  </div>
                </a-upload>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom: 12px"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 14 }"
                label="教师姓名   "
              >
                <a-input
                  placeholder="请输入教师姓名"
                  v-decorator="[
                    'realname',
                    { rules: [{ required: true, message: '请输入教师姓名' }] },
                    { initialValue: this.realname },
                  ]"
                />
                <!-- <span class="leave-num-count"></span> -->
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom: 12px"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 4 }"
                label="性别"
              >
                <j-dict-select-tag
                  placeholder="请选择性别"
                  v-decorator="[
                    'sex',
                    { rules: [{ required: false, message: '请选择性别' }] },
                  ]"
                  dictCode="sex"
                  :triggerChange="true"
                />
              </a-form-item>
            </a-col>
          </a-row>

          <!-- <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 4 }"
                label="所属校区">
                <a-select v-decorator="[
                    'sysOrgCode',
                    {rules: [{ required: false, message: '请选择所属校区' }]},
                    {'initialValue':this.sysOrgCode}
                  ]" placeholder="请选择所属校区">
                  <a-select-option value="" >请选择</a-select-option>
                  <a-select-option :value="item.id" v-for="(item,i) in campusList" :key={i}>{{item.departName}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row> -->
          <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom: 12px"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 14 }"
                label="手机号   "
              >
                <a-input
                  placeholder="请输入手机号"
                  v-decorator="[
                    'phone',
                    { rules: [{ required: true, message: '请输入手机号' }] },
                    { initialValue: this.phone },
                  ]"
                />
                <!-- <span class="leave-num-count"></span> -->
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom: 12px"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 14 }"
                label="擅长科目   "
              >
                <j-multi-select-tag
                  v-decorator="['skilled', {}, , {}]"
                  placeholder="请选择科目"
                  dictCode="subject"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom: 12px"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 14 }"
                label="教师简介">
                <j-editor
                  style="resize: none"
                  placeholder="请输入简介"
                  v-decorator="[
                    'comment',
                    { rules: [{ required: true, message: '请输入简介' }] },
                    { initialValue: this.comment },
                  ]"
                ></j-editor>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
      </a-card>

      <a-card
        :bordered="false"
        style="
          text-align: center;
          padding: 14px 0px;
          box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.06);
        "
      >
        <div class="a-row">
          <a-button
            style="
              text-align: center;
              width: 232px;
              line-height: 40px;
              height: 40px;
              font-size: 14px;
            "
            type="primary"
            @click="videoCreateOk()"
          >保存</a-button
          >
        </div>
      </a-card>
    </a-form>
  </div>
</template>

<script>
import JEditor from '@/components/jeecg/JEditor'
import Vue from 'vue'
import { ACCESS_TOKEN, TENANT_ID } from '@/store/mutation-types'

import { teacherAdd, teacherUpdate, getTeacherById } from '@/api/api'

import pick from 'lodash.pick'

import _ from 'lodash'
import moment from 'moment'

// function getBase64(file) {
//   return new Promise((resolve, reject) => {
//     const reader = new FileReader();
//     reader.readAsDataURL(file);
//     reader.onload = () => resolve(reader.result);
//     reader.onerror = error => reject(error);
//   });
// }
export default {
  name: 'ImageTextCreate',
  components: { JEditor },
  mixins: [],
  data() {
    return {
      realname: '', // 校区编号
      sex: '',
      sysOrgCode: '',
      phone: '',
      email: '',
      startDate: '',
      endDate: '',
      campusList: [],
      comment: '',
      avatar: '',
      faceloading: false,
      form: this.$form.createForm(this),
      loading: false,
      imageUrl: '',
      previewVisible: false,
      previewImage: '',

      url: {
        fileUpload: window._CONFIG['domianURL'] + '/sys/common/upload'
      }
    }
  },

  methods: {
    normFile(e) {
        console.log('Upload event:', e)
        if (Array.isArray(e)) {
          return e
        }
        return e && e.file && e.file.response && e.file.response && e.file.response.result && e.file.response.result.obsObjectUrl
      },
    courseCoverChange(info) {
      if (info.file.status === 'uploading') {
        this.faceloading = true
        return
      }
      if (info.file.status === 'done') {
        this.avatar = info.file.response.result.obsObjectUrl
        this.faceloading = false
      }
    },
    imgBeforeUpload(file) {
      const isJPG = /\.(gif|jpg|jpeg|png|GIF|JPG|PNG)$/.test(file.name)

      if (!isJPG) {
        this.$message.error('只能上传图片!')
      }

      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$message.error('图片大小要小于5MB!')
      }
      return isJPG && isLt5M
    },

    // 保存
    videoCreateOk() {
      this.form.validateFields((err, values) => {
        if (!err) {
          let id = this.id

          let valuesParam = {}
          valuesParam = { ...values }
          // valuesParam['registerTime']  = valuesParam['registerTime']?valuesParam['registerTime'].format('YYYY-MM-DD'):"";
          // valuesParam['expiredTime']  = valuesParam['expiredTime']?valuesParam['expiredTime'].format('YYYY-MM-DD'):"";
          valuesParam.birthday = valuesParam.birthday
            ? valuesParam.birthday.format('YYYY-MM-DD')
            : null
          valuesParam['avatar'] = this.avatar

          let opFun = ''
          if (_.isEmpty(this.id)) {
            opFun = teacherAdd(valuesParam)
          } else {
            valuesParam = { ...valuesParam, id }
            opFun = teacherUpdate(valuesParam)
          }
          opFun
            .then((res) => {
              if (res.success) {
                this.$message.success(res.message, () => {
                  this.$router.push({ path: '/teacherManagement/teacherList' })
                })
              } else {
                this.$message.warning(res.message)
              }
            })
            .finally(() => {})
        }
      })
    }
    // getCampusList(){
    //   getCampusList({pageSize:100000,pageNo:1}).then((res)=>{
    //     if(res.code==0){
    //       this.campusList = res.result.records;

    //     }else{
    //       this.$message.warning(res.message);
    //     }

    //   }).finally(() => {

    //   })
    // },
  },

  created() {
    const token = Vue.ls.get(ACCESS_TOKEN)
    let tenantid = Vue.ls.get(TENANT_ID)

    this.headers = { 'X-Access-Token': token, 'tenant_id': tenantid }

    this.id = this.$route.query.id

    // this.getCampusList();

    if (!_.isEmpty(this.id)) {
      getTeacherById({ id: this.id })
        .then((res) => {
          if (res.success) {
            console.log(res)
            let resultData = res.result
            // let address = [resultData.province,resultData.city,resultData.area]
            resultData.sex = resultData.sex + ''
            this.$nextTick(() => {
              this.form.setFieldsValue(
                pick(
                  resultData,
                  'weChat',
                  'realname',
                  'sex',
                  'skilled',
                  'phone',
                  'comment',
                  'avatar'
                )
              )

               this.form.setFieldsValue({
              birthday: resultData.birthday ? moment(resultData.birthday) : ''
              // registerTime: resultData.registerTime?moment(resultData.registerTime):"",
              // expiredTime: resultData.expiredTime?moment(resultData.expiredTime):"",
               })
              // this.form.setFieldsValue({registerTime:moment(resultData.registerTime),'registerTime':moment(resultData.registerTime)});
              // this.form.setFieldsValue({expiredTime:moment(resultData.expiredTime),'expiredTime':moment(resultData.expiredTime)});
              // this.form.setFieldsValue({birthday:moment(resultData.birthday),'registerTime':moment(resultData.birthday)});

              this.avatar = resultData.avatar
            })
          } else {
            this.$message.warning(res.message)
          }
        })
        .finally(() => {
          // that.confirmLoading = false;
          // that.checkedDepartNames = [];
          // that.userDepartModel.departIdList = {userId:'',departIdList:[]};
          // that.close();
        })
    }
  },
  computed: {
    uploadAction: function () {
      return this.url.fileUpload
    }
  }
}
</script>
<style scoped>
@import "~@assets/less/common.less";
</style>
<style lang="scss" scoped >
.course-create-wrap {
  .info-title {
    border-bottom: 1px solid #e7ecef;
    line-height: 50px;
    height: 50px;
    padding-left: 25px;
  }

  .info-content {
    .img-tip {
      color: #999999;
      font-size: 12px;
    }
  }
}
</style>
